export const BAR2 = {
  "yAxis": [{
    "axisLabel": {
      "formatter": "f$function(value){ return echartsUtils.formatNumber(value,'#,##0.00'); }",
      "color": "#616161",
      "show": false
    },
    "axisLine": {
      "lineStyle": {
        "color": "#939393"
      },
      "show": false
    },
    "show": true,
    "axisTick": {
      "show": true
    },
    "name": "产值(万)",
    "splitLine": {
      "lineStyle": {
        "color": "#e0dfdf",
        "width": 1,
        "type": "solid"
      },
      "show": true
    },
    "nameGap": 8,
    "splitNumber": 3,
    "nameTextStyle": {
      "color": "#616161"
    }
  }],
  "xcolDatas": {
    "07月": "07月",
    "08月": "08月",
    "05月": "05月",
    "06月": "06月",
    "03月": "03月",
    "04月": "04月",
    "01月": "01月",
    "02月": "02月",
    "10月": "10月",
    "11月": "11月",
    "09月": "09月"
  },
  "xAxis": {
    "axisLabel": {
      "rotate": 0,
      "color": "#616161",
      "show": true
    },
    "data": ["01月", "02月", "03月", "04月", "05月", "06月", "07月", "08月", "09月", "10月", "11月"],
    "axisLine": {
      "lineStyle": {
        "color": "#939393"
      },
      "show": true
    },
    "name": "",
    "axisTick": {
      "show": true,
      "interval": 0
    },
    "nameGap": 26,
    "nameLocation": "middle",
    "nameTextStyle": {
      "color": "#616161"
    }
  },
  "color": ["#4864a5", "#dae0ec", "#6D7A88", "#E3E5E6", "#F5A74D", "#DB843D", "#92A8CD", "#A47D7C", "#A5B557", "#EEF1DB", "#6D7A88", "#2AD62A", "#B09770", "#67C2DB", "#9C9900", "#103667", "#211551", "#79378B", "#AF4A92", "#8B8B00", "#8B2323", "#8470FF", "#7CFC00", "#e4e4e4", "#c6c6c6", "#519bff", "#fbb815", "#b87efe", "#90cefe", "#68faa0", "#70f3e0", "#fca487", "#e95882", "#d189fc", "#fde947", "#f86efd", "#0afefe", "#fffd08", "#74eba2", "#ffba59", "#F9F8F9"],
  "grid": {
    "top": 42,
    "left": 65,
    "borderWidth": 0,
    "bottom": 40,
    "show": true,
    "right": 10
  },
  "legend": {
    "data": ["2022年", "2021年"],
    "orient": "horizontal",
    "top": "bottom",
    "left": "left",
    "itemHeight": 7,
    "icon": "circle",
    "textStyle": {
      "color": "#333"
    }
  },
  "series": [{
    "barWidth": 30,
    "barMaxWidth": 40,
    "data": [0.1114, 315.179444, 958.74905, 989.979641, 1278.6621810000001, 1352.496071, 1392.737458, 1365.860627, 1317.33736, 1222.69977, 6505.239061],
    "name": "2022年",
    "itemStyle": {
      //  "color": "f$new echarts.graphic.LinearGradient(0,0,0,1,[{offset: 0, color: '#4864a5'},{offset: 0.5, color: '#4864a5'},{offset: 1, color: '#4864a5'}])",
      "borderRadius": 0
    },
    "type": "bar",
    "markPoint": {
      "data": []
    },
    "barMinHeight": 1
  }, {
    "barWidth": 30,
    "barMaxWidth": 40,
    "data": [null, null, 2.107932, null, null, null, null, null, null, null, null],
    "name": "2021年",
    "itemStyle": {
      // "color": "f$new echarts.graphic.LinearGradient(0,0,0,1,[{offset: 0, color: '#dae0ec'},{offset: 0.5, color: '#dae0ec'},{offset: 1, color: '#dae0ec'}])",
      "borderRadius": 0
    },
    "type": "bar",
    "markPoint": {
      "data": []
    },
    "barMinHeight": 1
  }],
  "extraCssText": "box-shadow: 0 0 3px rgba(0, 0, 0, 0.3)",
  "tooltip": {
    "formatter": "f$function(params){ \treturn echartsUtils.toolTipsNew(params, '1c04d4534ed55f494521cdc80e25576c')}",
    "backgroundColor": "rgba(45, 39, 38,0.9)",
    "axisPointer": {
      "type": "cross"
    },
    "trigger": "axis",
    "textStyle": {
      "color": "#ffffff"
    }
  },
  "axisPointer": {
    "link": {
      "xAxisIndex": "all"
    },
    "label": {
      "backgroundColor": "#777"
    }
  },
  "title": {
    "show": false
  },
  "animation": true
}

export const BASE_BAR2 = {
  "yAxis": [
    {
      "axisLabel": {
        "formatter": "f$function(value){ return formatNumber(value,'#,###'); }",
        "color": "#616161",
        "show": true
      },
      "axisLine": {
        "lineStyle": {
          "color": "#939393"
        },
        "show": true
      },
      "show": true,
      "axisTick": {
        "show": true
      },
      "name": "预估",
      "splitLine": {
        "lineStyle": {
          "color": "#e0dfdf",
          "width": 1,
          "type": "solid"
        },
        "show": true
      },
      "nameGap": 8,
      "splitNumber": 5,
      "nameTextStyle": {
        "color": "#616161"
      }
    },
    {
      "axisLabel": {
        "formatter": "f$function(value){ return formatNumber(value,'', true); }",
        "color": "#616161",
        "show": true
      },
      "axisLine": {
        "lineStyle": {
          "color": "#939393"
        },
        "show": true
      },
      "splitLine": {
        "show": false
      },
      "axisTick": {
        "show": true
      },
      "name": "实际",
      "nameGap": 8,
      "position": "right",
      "nameTextStyle": {
        "color": "#616161"
      }
    }],
  "xcolDatas": {
    "07月": "07月",
    "08月": "08月",
    "05月": "05月",
    "06月": "06月",
    "03月": "03月",
    "04月": "04月",
    "01月": "01月",
    "02月": "02月",
    "10月": "10月",
    "11月": "11月",
    "09月": "09月"
  },
  "xAxis": {
    "axisLabel": {
      "rotate": 0,
      "color": "#616161",
      "show": true
    },
    "data": ["03月", "01月", "02月", "04月", "05月", "06月", "07月", "08月", "09月", "10月", "11月"],
    "axisLine": {
      "lineStyle": {
        "color": "#939393"
      },
      "show": true
    },
    "name": "月",
    "axisTick": {
      "show": true,
      "interval": 0
    },
    "nameGap": 26,
    "nameLocation": "middle",
    "nameTextStyle": {
      "color": "#616161"
    }
  },
  "color": ["#4864a5", "#dae0ec", "#6D7A88", "#E3E5E6", "#F5A74D", "#DB843D", "#92A8CD", "#A47D7C", "#A5B557", "#EEF1DB", "#6D7A88", "#2AD62A", "#B09770", "#67C2DB", "#9C9900", "#103667", "#211551", "#79378B", "#AF4A92", "#8B8B00", "#8B2323", "#8470FF", "#7CFC00", "#e4e4e4", "#c6c6c6", "#519bff", "#fbb815", "#b87efe", "#90cefe", "#68faa0", "#70f3e0", "#fca487", "#e95882", "#d189fc", "#fde947", "#f86efd", "#0afefe", "#fffd08", "#74eba2", "#ffba59", "#F9F8F9"],
  "grid": {
    "top": 42,
    "left": 65,
    "borderWidth": 0,
    "bottom": 40,
    "show": true,
    "right": 10
  },
  "legend": {
    "data": ["2021-预估", "2022-预估", "2021-实际", "2022-实际"],
    "orient": "horizontal",
    "top": 5,
    "itemHeight": 7,
    "icon": "circle",
    "textStyle": {
      "color": "#333"
    },
    "right": 10
  },
  "series": [
    {
      "stack": "stack",
      "barMaxWidth": 40,
      "data": [3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782],
      "name": "2021-预估",
      "itemStyle": {
        // "color": new echarts.graphic.LinearGradient(0,0,0,1,[{offset: 0, color: '#4864a5'},{offset: 0.5, color: '#4864a5'},{offset: 1, color: '#4864a5'}]),
        "borderRadius": 0
      },
      "type": "bar",
      "barMinHeight": 1
    }, {
      "stack": "stack",
      "barMaxWidth": 40,
      "data": [42158.00, 42158, 42158, 42158, 42158, 18638408.24, 40282729.20, 2828157.29, 23098336.81, 18710061.34, 16207588.14],
      "name": "2022-预估",
      "itemStyle": {
        // "color": new echarts.graphic.LinearGradient(0,0,0,1,[{offset: 0, color: '#dae0ec'},{offset: 0.5, color: '#dae0ec'},{offset: 1, color: '#dae0ec'}]),
        "borderRadius": 0
      },
      "type": "bar",
      "barMinHeight": 1
    }, {
      "symbol": "circle",
      "barMaxWidth": 40,
      "data": [42158.64, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782, 3213782],
      "symbolSize": 6,
      "name": "2021-实际",
      "itemStyle": {
        //  "color": new echarts.graphic.LinearGradient(0,0,0,1,[{offset: 0, color: '#6D7A88'},{offset: 0.5, color: '#6D7A88'},{offset: 1, color: '#6D7A88'}]),
        "borderRadius": 0
      },
      "type": "line",
      "showAllSymbol": true,
      "barMinHeight": 1,
      "yAxisIndex": 1
    }, {
      "symbol": "circle",
      "barMaxWidth": 40,
      "data": [16576829.834880002, 5879538.541839999, 6213782.319839998, 18127255.973459996, 24069481.94542, 24281877.561140005, 24407176.6271, 25162043.773880005, 22115880.878799994, 24903844.0478, 1093409.9205999998],
      "symbolSize": 6,
      "name": "2022-实际",
      "itemStyle": {
        // "color": new echarts.graphic.LinearGradient(0,0,0,1,[{offset: 0, color: '#E3E5E6'},{offset: 0.5, color: '#E3E5E6'},{offset: 1, color: '#E3E5E6'}]),
        "borderRadius": 0
      },
      "type": "line",
      "showAllSymbol": true,
      "barMinHeight": 1,
      "yAxisIndex": 1
    }
  ],
  "extraCssText": "box-shadow: 0 0 3px rgba(0, 0, 0, 0.3)",
  "tooltip": {
    //	"formatter": "f$function(params){ \treturn echartsUtils.toolTipsNew(params, '8ad6c74c80b0c7c28add0e2fac198a86')}",
    "backgroundColor": "rgba(45, 39, 38,0.9)",
    "axisPointer": {
      "type": "cross"
    },
    "trigger": "axis",
    "textStyle": {
      "color": "#ffffff"
    }
  },
  "axisPointer": {
    "link": {
      "xAxisIndex": "all"
    },
    "label": {
      "backgroundColor": "#777"
    }
  },
  "title": {
    "show": false
  },
  "animation": true
};
export const HORIZONTAL_BAR2 = {
  "yAxis": {
    "axisLabel": {
      "rotate": 0,
      "color": "#616161",
      "show": true
    },
    "data": ["汉斯曼印度公司", "HQTS集团", "工业品事业部", "艾斯特公司", "汉斯曼俄罗斯公司", "汉斯曼越南公司", "汉斯曼上海公司", "HQTS共享服务中心", "汉斯曼福州公司", "宁波实验室", "兴恒实公司", "汉斯曼孟加拉合资公司", "机车事业部", "政府检验与贸易服务事业部", "投资发展委员会", "汉斯曼马来西亚公司", "吉田检品"],
    "axisLine": {
      "lineStyle": {
        "color": "#939393"
      },
      "show": true
    },
    "name": "",
    "axisTick": {
      "show": true,
      "interval": 0
    },
    "splitLine": {
      "lineStyle": {
        "color": ["#e0dfdf"],
        "width": 1,
        "type": "solid"
      },
      "show": true
    },
    "nameGap": 8,
    "splitNumber": 5,
    "type": "category",
    "nameTextStyle": {
      "color": "#616161"
    }
  },
  "xcolDatas": {
    "~`~`7 宁波实验室`~`8 Ningbo Lab`~`15 HQTS寧波試験室`~`~": "~`~`7 宁波实验室`~`8 Ningbo Lab`~`15 HQTS寧波試験室`~`~",
    "~`~`7 吉田检品`~`8 Yoshida`~`~": "~`~`7 吉田检品`~`8 Yoshida`~`~",
    "~`~`7 汉斯曼马来西亚公司`~`8 Helmsman Malaysia`~`~": "~`~`7 汉斯曼马来西亚公司`~`8 Helmsman Malaysia`~`~",
    "~`~`7 机车事业部`~`8 Auto Division`~`~": "~`~`7 机车事业部`~`8 Auto Division`~`~",
    "~`~`7 兴恒实公司`~`8 Xinghengshi`~`15 興恒実公司`~`~": "~`~`7 兴恒实公司`~`8 Xinghengshi`~`15 興恒実公司`~`~",
    "~`~`7 HQTS集团`~`8 HQTS GROUP`~`~": "~`~`7 HQTS集团`~`8 HQTS GROUP`~`~",
    "~`~`7 HQTS共享服务中心`~`8 HQTS SSC`~`~": "~`~`7 HQTS共享服务中心`~`8 HQTS SSC`~`~",
    "~`~`7 汉斯曼印度公司`~`8 Helmsman India`~`~": "~`~`7 汉斯曼印度公司`~`8 Helmsman India`~`~",
    "~`~`7 艾斯特公司`~`8 ASCO`~`15 ASCO公司`~`~": "~`~`7 艾斯特公司`~`8 ASCO`~`15 ASCO公司`~`~",
    "~`~`7 汉斯曼俄罗斯公司`~`8 Helmsman Russia`~`~": "~`~`7 汉斯曼俄罗斯公司`~`8 Helmsman Russia`~`~",
    "~`~`7 汉斯曼孟加拉合资公司`~`8 HQTS-IRG`~`~": "~`~`7 汉斯曼孟加拉合资公司`~`8 HQTS-IRG`~`~",
    "~`~`7 政府检验与贸易服务事业部`~`8 Government Inspection ａｎｄ Trade Service Division`~`~": "~`~`7 政府检验与贸易服务事业部`~`8 Government Inspection ａｎｄ Trade Service Division`~`~",
    "~`~`7 汉斯曼上海公司`~`8 Helmsman Shanghai`~`~": "~`~`7 汉斯曼上海公司`~`8 Helmsman Shanghai`~`~",
    "~`~`7 汉斯曼福州公司`~`8 Helmsman Fuzhou`~`15 HQTS漢斯曼福州公司`~`~": "~`~`7 汉斯曼福州公司`~`8 Helmsman Fuzhou`~`15 HQTS漢斯曼福州公司`~`~",
    "~`~`7 投资发展委员会`~`8 Investment Development Committee`~`~": "~`~`7 投资发展委员会`~`8 Investment Development Committee`~`~",
    "~`~`7 汉斯曼越南公司`~`8 Helmsman Vietnam`~`~": "~`~`7 汉斯曼越南公司`~`8 Helmsman Vietnam`~`~",
    "~`~`7 工业品事业部`~`8 Industry Product Division`~`~": "~`~`7 工业品事业部`~`8 Industry Product Division`~`~"
  },
  "xAxis": [{
    "axisLabel": {
      "formatter": "f$function(value){ return echartsUtils.formatNumber(value,'#,##0.00', true); }",
      "color": "#616161",
      "show": true
    },
    "axisLine": {
      "lineStyle": {
        "color": "#939393"
      },
      "show": true
    },
    "axisTick": {
      "show": true
    },
    "splitLine": {
      "lineStyle": {
        "color": ["#e0dfdf"],
        "width": 1,
        "type": "solid"
      },
      "show": true
    },
    "name": "金额(万)",
    "nameGap": 25,
    "nameLocation": "middle",
    "type": "value",
    "nameTextStyle": {
      "color": "#616161"
    }
  }],
  "color": ["#4864a5", "#dae0ec", "#6D7A88", "#E3E5E6", "#F5A74D", "#DB843D", "#92A8CD", "#A47D7C", "#A5B557", "#EEF1DB", "#6D7A88", "#2AD62A", "#B09770", "#67C2DB", "#9C9900", "#103667", "#211551", "#79378B", "#AF4A92", "#8B8B00", "#8B2323", "#8470FF", "#7CFC00", "#e4e4e4", "#c6c6c6", "#519bff", "#fbb815", "#b87efe", "#90cefe", "#68faa0", "#70f3e0", "#fca487", "#e95882", "#d189fc", "#fde947", "#f86efd", "#0afefe", "#fffd08", "#74eba2", "#ffba59", "#F9F8F9"],
  "grid": {
    "top": 27,
    "left": 141,
    "bottom": 60,
    "show": true,
    "right": 10
  },
  "legend": {
    "data": ["同比"],
    "orient": "horizontal",
    "top": "bottom",
    "left": "center",
    "icon": "none",
    "textStyle": {
      "color": "#333"
    }
  },
  "series": [{
    "barMaxWidth": 40,
    "data": [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
    "name": "同比",
    "itemStyle": {
      "color": "f$new echarts.graphic.LinearGradient(0,0,0,1,[{offset: 0, color: '#4864a5'},{offset: 0.5, color: '#4864a5'},{offset: 1, color: '#4864a5'}])",
      "borderRadius": 0
    },
    "label": {
      "formatter": "f$function(p){return echartsUtils.formatNumber(p.value,'#,##0.00') + '万'}",
      "color": "#191b1b",
      "show": true,
      "fontSize": 12,
      "position": "outside",
      "fontWeight": "normal"
    },
    "type": "bar",
    "barMinHeight": 10
  }],
  "tooltip": {
    "formatter": "f$function(params){ \treturn echartsUtils.toolTips(params, '#,##0.00', '万')}",
    "trigger": "axis"
  },
  "title": {
    "show": false
  },
  "animation": true
}
export const BASE_LINE2 = {
  title: {
    text: 'Stacked Area Chart'
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: {
        backgroundColor: '#6a7985'
      }
    }
  },
  legend: {
    data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
  },
  toolbox: {
    feature: {
      saveAsImage: {}
    }
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  },
  xAxis: [
    {
      type: 'category',
      boundaryGap: false,
      data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
    }
  ],
  yAxis: [
    {
      type: 'value'
    }
  ],
  series: [
    {
      name: 'Email',
      type: 'line',
      stack: 'Total',
      areaStyle: {},
      emphasis: {
        focus: 'series'
      },
      data: [120, 132, 101, 134, 90, 230, 210]
    },
    {
      name: 'Union Ads',
      type: 'line',
      stack: 'Total',
      areaStyle: {},
      emphasis: {
        focus: 'series'
      },
      data: [220, 182, 191, 234, 290, 330, 310]
    },
    {
      name: 'Video Ads',
      type: 'line',
      stack: 'Total',
      areaStyle: {},
      emphasis: {
        focus: 'series'
      },
      data: [150, 232, 201, 154, 190, 330, 410]
    },
    {
      name: 'Direct',
      type: 'line',
      stack: 'Total',
      areaStyle: {},
      emphasis: {
        focus: 'series'
      },
      data: [320, 332, 301, 334, 390, 330, 320]
    },
    {
      name: 'Search Engine',
      type: 'line',
      stack: 'Total',
      label: {
        show: true,
        position: 'top'
      },
      areaStyle: {},
      emphasis: {
        focus: 'series'
      },
      data: [820, 932, 901, 934, 1290, 1330, 1320]
    }
  ]
};
export const BASE_PIE2 = {
  "xcolDatas": {
    "固定成本": "固定成本",
    "变动成本": "变动成本",
    "其他成本": "其他成本",
    "未知": "NULLVAL"
  },
  "color": ["#5b9bd5", "#ed7d31", "#70ad47", "#ffc000", "#4472c4", "#91d024", "#b235e6", "#02ae75", "#5EA0DC", "#F78433", "#78B54D", "#FFC501"],
  "series": [{
    "data": [{
      "name": "其他成本",
      "value": 1130.1408490000001
    }, {
      "name": "变动成本",
      "value": 4583.367787
    }, {
      "name": "固定成本",
      "value": 398.338419
    }, {
      "name": "null",
      "value": 0.027
    }],
    "center": ["50%", "50%"],
    "name": "11",
    "labelLine": {
      "show": false,
      "length": 0
    },
    "label": {
      "formatter": "f$function(p){return p.name + ': ' + p.percent + '%'}",
      "show": true,
      "position": "outside"
    },
    "type": "pie",
    "radius": ["0%", "40%"]
  }],
  "tooltip": {
    "formatter": "f$function(params){   return  params.name + ': '+  echartsUtils.formatNumber(params.value, '#,##0.00')+'万(' + params.percent+'%)'; }"
  },
  "animation": true
}
export const DOUNT_PIE2 = {
  "xcolDatas": {
    "固定成本": "固定成本",
    "变动成本": "变动成本",
    "其他成本": "其他成本",
    "未知": "NULLVAL"
  },
  "color": ["#5b9bd5", "#ed7d31", "#70ad47", "#ffc000", "#4472c4", "#91d024", "#b235e6", "#02ae75", "#5EA0DC", "#F78433", "#78B54D", "#FFC501"],
  "series": [{
    "data": [{
      "name": "其他成本",
      "value": 1130.1408490000001
    }, {
      "name": "变动成本",
      "value": 4583.367787
    }, {
      "name": "固定成本",
      "value": 398.338419
    }, {
      "name": "null",
      "value": 0.027
    }],
    "center": ["50%", "50%"],
    "name": "",
    "labelLine": {
      "show": false,
      "length": 0
    },
    "label": {
      "formatter": "f$function(p){return p.name + ': ' + p.percent + '%'}",
      "show": true,
      "position": "outside"
    },
    "type": "pie",
    "radius": ["55%", "40%"]
  }],
  "tooltip": {
    "formatter": "f$function(params){   return  params.name + ': '+  echartsUtils.formatNumber(params.value, '#,##0.00')+'万(' + params.percent+'%)'; }"
  },
  "animation": true
}
export const BASE_FUNNEL2 =    {
  title: {
    text: '总用户行为漏斗图'
  },
  legend: {
    bottom:40,
    data: []/*  ['点击','收藏','加购','购买'] */
  },
  series: [
    {
      name: '',
      type: 'funnel',
      left: '10%',
      width: '80%',
      gap: 10,
      minSize: '0%',
      maxSize: '100%',
      label: {
        show:false
      },
      labelLine:{
        length: 100,
        show:false
      },
      data: [
     /*    {value: 1447148, name: '加购',
          itemStyle: {
            color: '#4da7db'
          }
        },
        {value: 756141, name: '收藏',
          itemStyle: {
            color: '#4e99de'
          },

        },
        {value: 523833, name: '购买',
          itemStyle: {
            color: '#0083c7'
          },

        },
        {value: 23334686, name: '点击',
          itemStyle: {
            color: '#53b8e2'
          }
        } */
      ]
    },
    {
      name: '',
      type: 'funnel',
      gap: 10,
      label: {
        normal: {
          position: 'inside',
          formatter: function (params) {
            return params.data.name + '数 : ' + params.data.num + '\n\n' + params.data.value+'%';
          },
          textStyle: {
            color: '#333',
            fontSize:16
          }
        }

      },
      itemStyle: {
        normal: {
          color: 'transparent',
          borderWidth:0,
          opacity: 0
        }
      },
      data: [
       /*  {value: 100, name: '点击', num: 23334686 },
        {value: 3.24, name: '收藏', num: 756141 },
        {value: 6.2, name: '加购', num: 1447148 },
        {value: 2.24, name: '购买', num: 523833 }, */
      ]
    }
  ]
}

export const BASE_GAUGE2 = {
  "title": {

  },
  "series": [{
    "pointer": {
      "show": false,
      "length": "90%",
      "width": 0
    },
    "startAngle": 180,
    "data": [],
    "max": 100,
    "clockwise": true,
    "endAngle": 0,
    "splitNumber": 2,
    "type": "gauge",
    "title": {
      "offsetCenter": [0, "-10%"],
      "show": true,
      "textStyle": {
        "color": "#202224",
        "fontSize": 14
      }
    },
    "axisLabel": {
      "show": false
    },
    "min": 0,
    "axisLine": {
      "lineStyle": {
        "color": [
          [1, "#DAD7D7"]
        ],
        "width": 16
      },
      "roundCap": true
    },
    "name": "",
    "axisTick": false,
    "splitLine": {
      "show": false
    },
    "progress": {
      "show": true,
      "width": 16,
      "roundCap": true
    },
    "detail": {
      "offsetCenter": [0, "-40%"],
      "formatter": "{value}%",
      "borderRadius": 8,
      "show": true,
      "textStyle": {
        "color": "#202224",
        "fontSize": 20
      }
    },
    "radius": 100
  }],
  "tooltip": {
    //"formatter": "f$function(params){   return  params.name + ': '+  echartsUtils.formatNumber(params.value, '#,##0.00')+''; }"
  },
  "animation": true
}

export const BASE_MIX2 = {
  "yAxis": [{
    "axisLabel": {
      "formatter": "f$function(value){ return echartsUtils.formatNumber(value,'#,##0.00'); }",
      "color": "#616161",
      "show": true
    },
    "axisLine": {
      "lineStyle": {
        "color": "#939393"
      },
      "show": true
    },
    "show": true,
    "axisTick": {
      "show": true
    },
    "name": "支出(万)",
    "splitLine": {
      "lineStyle": {
        "color": "#e0dfdf",
        "width": 1,
        "type": "solid"
      },
      "show": true
    },
    "nameGap": 8,
    "splitNumber": 3,
    "nameTextStyle": {
      "color": "#616161"
    }
  }, {
    "axisLabel": {
      "formatter": "f$function(value){ return echartsUtils.formatNumber(value,'', true); }",
      "color": "#616161",
      "show": true
    },
    "axisLine": {
      "lineStyle": {
        "color": "#939393"
      },
      "show": true
    },
    "splitLine": {
      "show": false
    },
    "axisTick": {
      "show": true
    },
    "name": "预算完成率(%)",
    "nameGap": 8,
    "position": "right",
    "nameTextStyle": {
      "color": "#616161"
    }
  }],
  "xcolDatas": {
    "07月": "07月",
    "08月": "08月",
    "05月": "05月",
    "06月": "06月",
    "03月": "03月",
    "04月": "04月",
    "01月": "01月",
    "12月": "12月",
    "02月": "02月",
    "10月": "10月",
    "11月": "11月",
    "09月": "09月"
  },
  "xAxis": {
    "axisLabel": {
      "rotate": 0,
      "color": "#616161",
      "show": true
    },
    "data": ["01月", "02月", "03月", "04月", "05月", "06月", "07月", "08月", "09月", "10月", "11月", "12月"],
    "axisLine": {
      "lineStyle": {
        "color": "#939393"
      },
      "show": false
    },
    "name": "月",
    "axisTick": {
      "show": false,
      "interval": 0
    },
    "nameGap": 26,
    "nameLocation": "middle",
    "nameTextStyle": {
      "color": "#616161"
    }
  },
  "color": ["#4864a5", "#dae0ec", "#6D7A88", "#E3E5E6", "#F5A74D", "#DB843D", "#92A8CD", "#A47D7C", "#A5B557", "#EEF1DB", "#6D7A88", "#2AD62A", "#B09770", "#67C2DB", "#9C9900", "#103667", "#211551", "#79378B", "#AF4A92", "#8B8B00", "#8B2323", "#8470FF", "#7CFC00", "#e4e4e4", "#c6c6c6", "#519bff", "#fbb815", "#b87efe", "#90cefe", "#68faa0", "#70f3e0", "#fca487", "#e95882", "#d189fc", "#fde947", "#f86efd", "#0afefe", "#fffd08", "#74eba2", "#ffba59", "#F9F8F9"],
  "grid": {
    "top": 42,
    "left": 65,
    "borderWidth": 0,
    "bottom": 40,
    "show": true,
    "right": 42
  },
  "legend": {
    "data": ["2022-支出(万)", "2021-支出(万)", "2022-预算完成率(%)", "2021-预算完成率(%)"],
    "orient": "horizontal",
    "top": "bottom",
    "left": "left",
    "itemHeight": 7,
    "icon": "circle",
    "textStyle": {
      "color": "#333"
    }
  },
  "series": [{
    "barMaxWidth": 40,
    "data": [3.333217, 441.72078099999993, 686.780506, 679.169056, 775.919771, 1082.999009, 934.1190720000001, 904.042591, 517.915119, 80.900586, 0.539461, null],
    "name": "2022-支出(万)",
    "itemStyle": {
      "color": "f$new echarts.graphic.LinearGradient(0,0,0,1,[{offset: 0, color: '#6D7A88'},{offset: 0.5, color: '#6D7A88'},{offset: 1, color: '#6D7A88'}])",
      "borderRadius": 0
    },
    "type": "bar",
    "markPoint": {
      "data": []
    },
    "barMinHeight": 1
  }, {
    "barMaxWidth": 40,
    "data": [null, null, null, null, null, null, null, null, null, null, null, 0.3706],
    "name": "2021-支出(万)",
    "itemStyle": {
      "color": "f$new echarts.graphic.LinearGradient(0,0,0,1,[{offset: 0, color: '#dae0ec'},{offset: 0.5, color: '#dae0ec'},{offset: 1, color: '#dae0ec'}])",
      "borderRadius": 0
    },
    "type": "bar",
    "markPoint": {
      "data": []
    },
    "barMinHeight": 1
  }, {
    "symbol": "circle",
    "barMaxWidth": 40,
    "data": [0.2400, 43.2000, 50.0700, 49.7800, 53.8400, 75.0800, 59.6500, 64.4100, 35.6200, 6.4600, 0.0400, null],
    "symbolSize": 6,
    "name": "2022-预算完成率(%)",
    "itemStyle": {
      "color": "f$new echarts.graphic.LinearGradient(0,0,0,1,[{offset: 0, color: '#F5A74D'},{offset: 0.5, color: '#F5A74D'},{offset: 1, color: '#F5A74D'}])",
      "borderRadius": 0
    },
    "type": "line",
    "markLine": {
      "symbol": "none",
      "silent": true,
      "lineStyle": {
        "normal": {
          "color": "red"
        }
      },
      "data": [{
        "yAxis": "100",
        "label": {
          "formatter": "100"
        }
      }]
    },
    "markPoint": {
      "data": []
    },
    "showAllSymbol": true,
    "barMinHeight": 1,
    "yAxisIndex": 1
  }, {
    "symbol": "circle",
    "barMaxWidth": 40,
    "data": [null, null, null, null, null, null, null, null, null, null, null, null],
    "symbolSize": 6,
    "name": "2021-预算完成率(%)",
    "itemStyle": {
      "color": "f$new echarts.graphic.LinearGradient(0,0,0,1,[{offset: 0, color: '#F5A74D'},{offset: 0.5, color: '#F5A74D'},{offset: 1, color: '#F5A74D'}])",
      "borderRadius": 0
    },
    "type": "line",
    "markLine": {
      "symbol": "none",
      "silent": true,
      "lineStyle": {
        "normal": {
          "color": "red"
        }
      },
      "data": [{
        "yAxis": "100",
        "label": {
          "formatter": "100"
        }
      }]
    },
    "markPoint": {
      "data": []
    },
    "showAllSymbol": true,
    "barMinHeight": 1,
    "yAxisIndex": 1
  }],
  "extraCssText": "box-shadow: 0 0 3px rgba(0, 0, 0, 0.3)",
  "tooltip": {
    "formatter": "f$function(params){ \treturn echartsUtils.toolTipsNew(params, 'c6ab4f7196494f284d28efc1503a5456')}",
    "backgroundColor": "rgba(45, 39, 38,0.9)",
    "axisPointer": {
      "type": "cross"
    },
    "trigger": "axis",
    "textStyle": {
      "color": "#ffffff"
    }
  },
  "axisPointer": {
    "link": {
      "xAxisIndex": "all"
    },
    "label": {
      "backgroundColor": "#777"
    }
  },
  "title": {
    "show": false
  },
  "animation": true
}

// 收入对比柱状图专用
export const BAR_INCOME_COMPARE = {
  title: {
    text: '',
    textStyle: {
      fontWeight: 'normal'
    }
  },
  grid: {
    containLabel: true
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow'
    }
  },
  legend: {},
  xAxis: {
    data: []
  },
  yAxis: {
    type: 'value'
  },
  series: [],
  /* dataZoom: [
    {
      type: 'slider',
      show: false,
      xAxisIndex: [0],
      start: 0,
      end: 100
    },
    {
      type: 'slider',
      show: false,
      yAxisIndex: [0],
      left: '93%',
      start: 0,
      end: 100
    },
    {
      type: 'inside',
      xAxisIndex: [0],
      start: 0,
      end: 100
    },
    {
      type: 'inside',
      yAxisIndex: [0],
      start: 0,
      end: 100
    }
  ] */
}
